import {
  SET_TRENDING_PRODUCTS_LOADING,
  GET_TRENDING_PRODUCTS_SUCCESS,
  GET_TRENDING_PRODUCTS_ERROR,
} from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const getTrendingProducts = (params) => async (dispatch) => {
  try {
    dispatch({ type: SET_TRENDING_PRODUCTS_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    const queryParams = {
      companyId,
      branchId,
      ...params,
    };

    const res = await Axios.get(
      `/api/dashboard/purchase-items/find-trending-products`,
      {
        params: queryParams,
      }
    );

    dispatch({
      type: GET_TRENDING_PRODUCTS_SUCCESS,
      payload: {
        data: res.data.data,
        pagination: res.data.pagination,
      },
    });
  } catch (err) {
    dispatch({
      type: GET_TRENDING_PRODUCTS_ERROR,
      payload: err.message || 'Failed to fetch trending products',
    });
  }
};

export const setTrendingProductsLoading = (loading) => ({
  type: SET_TRENDING_PRODUCTS_LOADING,
  payload: loading,
});

export const clearTrendingProductsError = () => ({
  type: GET_TRENDING_PRODUCTS_ERROR,
  payload: null,
});

export const exportTrendingProducts = (params) => async (dispatch) => {
  try {
    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;

    // Generate timestamp for unique filename
    const getTimestampString = () => {
      const pad = (num) => String(num).padStart(2, '0');
      const d = new Date();
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
    };

    const requestBody = {
      columns: [
        {
          key: 'code',
          header: 'Product Code',
        },
        {
          key: 'name',
          header: 'Product Name',
        },
        {
          key: 'sum_total_amount',
          header: 'Total Sales Amount',
        },
        {
          key: 'sum_quantity',
          header: 'Quantity Sold',
        },
        {
          key: 'sum_cost',
          header: 'Total Cost',
        },
        {
          key: 'sum_profit',
          header: 'Total Profit',
        },
      ],
      filename: `product_summary_export_${getTimestampString()}.xlsx`,
      sheetName: 'Product summary',
      companyId,
      branchId,
      ...params,
    };

    const response = await Axios.post(
      '/api/dashboard/purchase-items/export-trending-products-excel',
      requestBody,
      {
        responseType: 'blob',
        headers: {
          Accept:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }
    );

    const contentDisposition = response?.headers?.['content-disposition'];
    let downloadFileName =
      requestBody.filename || `product_summary_export.xlsx`;
    if (contentDisposition && contentDisposition.includes('filename=')) {
      const match = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
      );
      downloadFileName = decodeURIComponent(
        match?.[1] || match?.[2] || downloadFileName
      );
    }

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downloadFileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Export failed', error);
  }
};
